import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 0px 8px rgba(0, 17, 68, 0.08);
  border-radius: 8px;
  position: relative;
  width: 100%;
  max-height: 350px;
  align-items: flex-start;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: stretch;
    max-height: none;
  }

  a:hover {
    opacity: 1;
  }
`;

export const ImageSliderWrapper = styled.div`
  width: 244px;
  height: 350px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    min-height: 200px;
    height: 200px;
  }
`;

export const InformationWrapper = styled.div`
  width: 100%;
  padding: 24px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;

export const Title = styled.span`
  font-size: 20px;
  font-weight: 700;
  max-width: 420px;
  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
    width: 100%;
  }
`;

export const SubtitleWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 12px;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
`;

export const IconText = styled.span<{ dark?: boolean }>`
  font-size: 12px;
  margin-left: 4px;
  color: ${({ theme, dark }) => theme.palette[dark ? 'grey800' : 'grey600']};
`;

export const SubtitleSeperator = styled.div`
  height: 12px;
  width: 1px;
  background: ${({ theme }) => theme.palette.grey300};
  margin: 0 8px;
`;

export const StarRatingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  margin-top: 8px;

  svg {
    width: 12px;
    height: 11px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 4px;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  margin: 24px 0;
  background-color: ${({ theme }) => theme.palette.grey300};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: none;
  }
`;

export const HighlightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 500px; /* desktop max width */

  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    gap: 4px;
    flex-direction: column;
  }
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 4px;
    margin-top: 28px;
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const FeatureWrapper = styled.div`
  margin-bottom: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 4px;
  }
`;

export const Feature = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.grey1100};
  margin-left: 4px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 10px;
  }
`;

export const FreeCancelletionWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 8px;
`;

export const DiscountBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: flex-end;
  align-items: flex-end;
  margin: 0 0 5px 0;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: row;

    justify-content: flex-end;
    text-align: right;
    margin: 0 auto 10px 0;
    padding-top: 20px;
  }
`;

export const MileAndPriceWrapper = styled.div<{ isReverse?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${({ isReverse }) =>
    isReverse &&
    css`
      align-items: flex-start;
    `}
`;

export const PriceLabelBoxWrapper = styled.div`
  grid-row: 4/5;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-bottom: 10px;
`;

export const Badge = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  background-color: ${({ theme }) => theme.palette.grey1100};
  color: ${({ theme }) => theme.palette.white};
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const EventsContainer = styled.div`
  display: flex;
  flex-direction: row; /* yatay scroll */
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  max-width: 500px;
  margin-top: 3px;
  gap: 8px;
  padding-bottom: 4px; /* scrollbar alanı */
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  /* Scrollbar stilleri */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.palette.grey200};
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.grey400};
    border-radius: 3px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    max-width: none;
  }
`;

export const EventsWrapper = styled.div`
  height: 70px;
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme }) => theme.palette.grey300};
  border-radius: 8px;

  min-width: 250px;
`;

export const EventImage = styled.img`
  height: 69px;
  width: 50px;
  border-radius: 8px;
`;

export const EventContent = styled.div`
  min-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px;
`;

export const EventTitle = styled.span`
  font-size: 12px;
  font-weight: 550;
`;

export const EventDescription = styled.span`
  font-size: 12px;
`;

export const NextEvents = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 11px;
  font-weight: 550;
`;

export const LocationRatings = styled.div`
  display: flex;
  gap: 16px;
`;
